import React, { useState, useEffect, useRef } from "react";
import { useInView } from "react-intersection-observer";
import styles from "./LandingHome.module.css";
import phone from '../../Asset/SVG (1).svg';
import email from '../../Asset/SVG (2).svg';
import locations from '../../Asset/SVG (3).svg';
import herobg from '../../Asset/hero-bg.png';
import ogunlogo from '../../Asset/ognewlogo.png';
import purse from '../../Asset/Background (1).png';
import work from '../../Asset/Background (2).png';
import invoice from "../../Asset/Background (3).png";
import telephone from "../../Asset/Background (5).png";
import invoices from "../../Asset/Background (6).png";
import homes from "../../Asset/HomeSVG.svg";
import arrownxt from "../../Asset/arrowforward.svg";
import greenmarks from "../../Asset/marks-green.svg";
import calls from "../../Asset/CallVector.svg";
import icons from "../../Asset/icons2.svg";
import icons2 from "../../Asset/arrowleftwhite.svg";
import persons from "../../Asset/personss.svg";
import spanner from "../../Asset/spanner.svg";
import calculator from "../../Asset/calculator.svg";
import { Modal, Accordion, Button, Carousel, Form } from "react-bootstrap";
import exe from "./exe.svg"
import community from "./community.svg"
import rely from "./reliability.svg"
import love from "./love.svg"
import img from "../../Asset/new1.jpeg"
import img2 from "../../Asset/new2.jpeg"
import img3 from "../../Asset/new3.jpeg"
import date from "./date.svg"
import arrow from "./arrow.svg"
import arBlk from "./arrowBlack.svg"
import fly from "./fly.svg"
import loc from "./location.svg"
import call from "./call.svg"
import mail from "./mail.svg"
import hour from "./hour.svg"
import chat from "./chat.svg"
import ogswc from "./ogswc.png"
import Swal from 'sweetalert2';
import facebook from "./facebok.svg"
import twitter from "./twitter.svg"
import instagram from "./instagram.svg"
import linkedln from "./linkedln.svg"
import { useLocation, useNavigate } from "react-router-dom";

const HomePage = () => {
  const [refHero, inViewHero] = useInView({ threshold: 0.1 });
  const [refServices, inViewServices] = useInView({ threshold: 0.1 });
  const [refContactUs, inViewContactUs] = useInView({ threshold: 0.1 });
  const [refAbout, inViewAbout] = useInView({ threshold: 0.1 });
  const [refNews, inViewNews] = useInView({ threshold: 0.1 });
  const [activeSection, setActiveSection] = useState("");
  const sectionRef = useRef(null);
  const heroRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const year = new Date().getFullYear();
  const [isOpen, setIsOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const LITERS_PER_FLUSH = 9;           // avg per flush
const SHOWER_FLOW_LPM = 9;            // shower flow (liters/min)
const FAUCET_FLOW_LPM = 6;            // tap flow (liters/min)
const FAUCET_MIN_PER_DAY = 5;         // avg minutes per faucet/day
const WM_LITERS_PER_CYCLE = 70;       // washing machine liters per cycle
const DAYS_PER_MONTH = 30;


 const [householdPeople, setHouseholdPeople] = useState('');
  const [householdToilets, setHouseholdToilets] = useState('');
  const [toiletFlushFrequency, setToiletFlushFrequency] = useState('');
  const [showerFrequency, setShowerFrequency] = useState('');
  const [showerDuration, setShowerDuration] = useState('');
  const [faucetCount, setFaucetCount] = useState('');
  const [washingMachineUsage, setWashingMachineUsage] = useState('');

  const format = (n, digits = 2) =>
    Number(n).toLocaleString(undefined, {
      minimumFractionDigits: digits,
      maximumFractionDigits: digits,
    });

  // Map selects to numeric values
  const mapPeople = (val) => {
    switch (val) {
      case '0-10': return 5;
      case '10-20': return 15;
      case '20-40': return 30;
      case '50+': return 50;
      default: return 0;
    }
  };

  const mapNumber = (val) => {
    if (!val) return 0;
    if (val.endsWith('+')) return parseInt(val, 10); // '8+' => 8
    const n = parseInt(val, 10);
    return isNaN(n) ? 0 : n;
  };

  const mapFrequency = (val) => {
    // Used for flushes per toilet per day
    switch (val) {
      case 'Once': return 1;
      case '2-3 times': return 2.5;
      case '3-5 times': return 4;
      case '5-9 times': return 7;
      case '10+ times': return 10;
      default: return 0;
    }
  };

  const mapShowerPerPersonPerDay = (val) => {
    switch (val) {
      case 'Once': return 1;
      case 'Twice': return 2;
      case '2-3 times': return 2.5;
      case '3-5 times': return 4;
      case '5-9 times': return 7;
      case '10+ times': return 10;
      default: return 0;
    }
  };

  const mapWashingCyclesPerWeek = (val) => {
    switch (val) {
      case 'Once': return 1;
      case 'Twice': return 2;
      case 'Often': return 4;
      case 'Everyday': return 7;
      default: return 0;
    }
  };

  const clearForm = () => {
  setHouseholdPeople('');
  setHouseholdToilets('');
  setToiletFlushFrequency('');
  setShowerFrequency('');
  setShowerDuration('');
  setFaucetCount('');
  setWashingMachineUsage('');
};

  const handleSubmit = async (e) => {
  e.preventDefault();

  // validate
  if (
    !householdPeople ||
    !householdToilets ||
    !toiletFlushFrequency ||
    !showerFrequency ||
    !showerDuration ||
    !faucetCount ||
    !washingMachineUsage
  ) {
    await Swal.fire({
      icon: 'warning',
      title: 'Missing info',
      text: 'Please select an option for every question.',
    });
    return;
  }

  // compute first (instant)
  const people = mapPeople(householdPeople);
  const toilets = mapNumber(householdToilets);
  const flushesPerToiletPerDay = mapFrequency(toiletFlushFrequency);
  const showersPerPersonPerDay = mapShowerPerPersonPerDay(showerFrequency);
  const minutesPerShower = mapNumber(showerDuration);
  const faucets = mapNumber(faucetCount);
  const cyclesPerWeek = mapWashingCyclesPerWeek(washingMachineUsage);

  const toiletsLiters = toilets * flushesPerToiletPerDay * LITERS_PER_FLUSH;
  const showersLiters = people * showersPerPersonPerDay * minutesPerShower * SHOWER_FLOW_LPM;
  const faucetsLiters = faucets * FAUCET_MIN_PER_DAY * FAUCET_FLOW_LPM;
  const washingLiters = (cyclesPerWeek * WM_LITERS_PER_CYCLE) / 7;

  const totalLitersPerDay = toiletsLiters + showersLiters + faucetsLiters + washingLiters;
  const m3PerDay = totalLitersPerDay / 1000;
  const m3PerMonth = m3PerDay * DAYS_PER_MONTH;

  // show loading briefly
  await Swal.fire({
    title: 'Calculating your water usage…',
    allowOutsideClick: false,
    allowEscapeKey: false,
    showConfirmButton: false,
    didOpen: () => Swal.showLoading(),
    timer: 800,             // show spinner ~0.8s
    timerProgressBar: true,
  });

  // show results; on OK -> close modal + clear inputs
  await Swal.fire({
    icon: 'info',
    title: 'Estimated Water Usage',
    html: `
      <div style="text-align:left">
        <p><strong>Daily total:</strong> ${format(totalLitersPerDay, 0)} L (${format(m3PerDay, 3)} m³)</p>
        <p><strong>Monthly total (30 days):</strong> ${format(m3PerMonth, 3)} m³</p>
        <hr />
        <p><strong>Breakdown (liters/day):</strong></p>
        <ul style="margin-left:16px">
          <li>Toilets: ${format(toiletsLiters, 0)} L</li>
          <li>Showers: ${format(showersLiters, 0)} L</li>
          <li>Faucets: ${format(faucetsLiters, 0)} L</li>
          <li>Washing Machine: ${format(washingLiters, 0)} L</li>
        </ul>
      </div>
    `,
    confirmButtonText: 'OK',
  });

  // after dismissing the result
  setShowModal(false);
  clearForm();
};

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 95);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add(styles.animate);
          }
        });
      },
      { threshold: 0.5 }
    );

    if (heroRef.current) {
      observer.observe(heroRef.current);
    }

    return () => {
      if (heroRef.current) {
        observer.unobserve(heroRef.current);
      }
    };
  }, []);

  // Smooth scroll handler
  const handleSmoothScroll = (e, id) => {
    e.preventDefault(); // Prevent default anchor behavior
    const target = document.getElementById(id);
    if (target) {
      target.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  // React.useEffect(() => {
  //   if (inViewIsp) {
  //     setStartTyping(true);
  //   }
  // }, [inViewIsp]);

  useEffect(() => {
    const sections = document.querySelectorAll("section");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveSection(entry.target.id);
          }
        });
      },
      { threshold: 0.7 }
    );

    sections.forEach((section) => observer.observe(section));
    return () => observer.disconnect();
  }, []);

  const scrollToTop = () => {
    sectionRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  };




  const toggleMenu = () => {
    setIsOpen((prev) => !prev);
  };

  const handleSignup = () => {
    navigate("/signup");
  };
  const handleSignin = () => {
    navigate("/login");
  };

  return (
    <div className={styles.container}>
    {/* <!-- SEO Meta Tags --> */}
    <meta name="description" content="Ogun State Water Corporation web application. Pay water bills, report leaks, request new connections, and access safe water services online." />
    <meta name="keywords" content="water corporation, state water, pay water bills, water services, online water payment, water connection, leak reporting, clean water, MDA's in Ogun State" />
    <meta name="author" content="Ogun State Water Corporation" />


      {/* Header */}
    <div className={styles.cdetails}>
        <div className={styles.cddetails1}>
        <div className={styles.cdflout}>
        <div>
        <img src={phone} alt="telephone" />
        </div>
        <p>+2347080601161,+2348068241741</p>
      </div>
      <div className={styles.cdflout}>
      <div>
            <img src={email} alt="email" />
            </div>
            <p>info@ogswc.ogunstate.gov.ng</p>
      </div>
        </div>
        <div className={styles.cdflout2}>
        <div>
        <img src={locations} alt="location icon" />
        </div>
        <p>Presidential Boulevard, Oke-Mosan, Abeokuta, P.M.B 2074.</p>
        </div>
    </div>

      <header className={`${styles.header} ${scrolled ? styles.scrolled : ""}`}>
        <div className={styles.logoSection}>
        <div>
          <img src={ogunlogo} alt="Logo" className={styles.logo} />
        </div>
        <div className={styles.logolay}>
           <h1 className={styles.logbgtext}>OGSWC</h1>
          <span className={styles.logoText}>Ogun State Water Corporation</span>
        </div>
        </div>
        <div>
        <nav className={styles.nav}> 
          <a
              href="#home"
              onClick={(e) => handleSmoothScroll(e, "home")}
              className={`${styles.navLink} ${
                activeSection === "Home" ? styles.active : ""
              }`}
            >Home</a>
          <a
              href="#services"
              onClick={(e) => handleSmoothScroll(e, "services")}
              className={`${styles.navLink} ${
                activeSection === "Services" ? styles.active : ""
              }`}
            >Services</a>
          <a
              href="#about"
              onClick={(e) => handleSmoothScroll(e, "about")}
              className={`${styles.navLink} ${
                activeSection === "About" ? styles.active : ""
              }`}
            >About</a>
          <a
              href="#news"
              onClick={(e) => handleSmoothScroll(e, "news")}
              className={`${styles.navLink} ${
                activeSection === "News" ? styles.active : ""
              }`}
            >News</a>
          <a
              href="#contact"
              onClick={(e) => handleSmoothScroll(e, "contact")}
              className={`${styles.navLink} ${
                activeSection === "Contact" ? styles.active : ""
              }`}
            >Contact</a>
             {/* <a href="#home">Home</a> */}
              {/* <a href="#services">Services</a> */}
              {/* <a href="#about">About</a> */}
          {/* <a href="#news">News</a> */}
          {/* <a href="#contact"></a> */}
        </nav>
        </div>
<Modal show={showModal} onHide={() => setShowModal(false)} centered size="md">
      <Modal.Header closeButton style={{ borderBottom: 'none' }}>
        <Modal.Title>Water Usage Calculator</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3" controlId="householdPeople">
            <Form.Label>How many people live in your household?</Form.Label>
            <Form.Select
              value={householdPeople}
              onChange={(e) => setHouseholdPeople(e.target.value)}
            >
              <option value="">Select</option>
              <option>0-10</option>
              <option>10-20</option>
              <option>20-40</option>
              <option>50+</option>
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3" controlId="householdToilets">
            <Form.Label>How many toilets do you have in your house?</Form.Label>
            <Form.Select
              value={householdToilets}
              onChange={(e) => setHouseholdToilets(e.target.value)}
            >
              <option value="">Select</option>
              <option>1</option><option>2</option><option>3</option><option>4</option>
              <option>5</option><option>6</option><option>7</option><option>8+</option>
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3" controlId="toiletFlushFrequency">
            <Form.Label>How many times do you flush each toilet on average daily?</Form.Label>
            <Form.Select
              value={toiletFlushFrequency}
              onChange={(e) => setToiletFlushFrequency(e.target.value)}
            >
              <option value="">Select</option>
              <option>Once</option>
              <option>2-3 times</option>
              <option>3-5 times</option>
              <option>5-9 times</option>
              <option>10+ times</option>
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3" controlId="showerFrequency">
            <Form.Label>How many times do household members shower per day?</Form.Label>
            <Form.Select
              value={showerFrequency}
              onChange={(e) => setShowerFrequency(e.target.value)}
            >
              <option value="">Select</option>
              <option>Once</option>
              <option>Twice</option>
              <option>2-3 times</option>
              <option>3-5 times</option>
              <option>5-9 times</option>
              <option>10+ times</option>
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3" controlId="showerDuration">
            <Form.Label>Average shower duration (in minutes)</Form.Label>
            <Form.Select
              value={showerDuration}
              onChange={(e) => setShowerDuration(e.target.value)}
            >
              <option value="">Select</option>
              <option>5</option><option>10</option><option>15</option>
              <option>20</option><option>25</option><option>30</option>
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3" controlId="faucetCount">
            <Form.Label>Number of faucets (water taps) in your household</Form.Label>
            <Form.Select
              value={faucetCount}
              onChange={(e) => setFaucetCount(e.target.value)}
            >
              <option value="">Select</option>
              <option>1</option><option>2</option><option>3</option>
              <option>4</option><option>5</option><option>6</option>
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3" controlId="washingMachineUsage">
            <Form.Label>If you own a washing machine, how many times do you use it per week?</Form.Label>
            <Form.Select
              value={washingMachineUsage}
              onChange={(e) => setWashingMachineUsage(e.target.value)}
            >
              <option value="">Select</option>
              <option>Once</option>
              <option>Twice</option>
              <option>Often</option>
              <option>Everyday</option>
            </Form.Select>
          </Form.Group>

          <div /* className={styles.btnlayouts} */ style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
            <Button variant="outline-secondary" onClick={() => setShowModal(false)}>
              Cancel
            </Button>
            <Button variant="success" type="submit">
              Submit
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
        <div className={styles.headerButtons}>
        <div>
        <button onClick={handleSignin} className={styles.signIn}>Sign In</button>
        </div>
          <div>
          <button onClick={handleSignup} className={styles.signUp}>Sign Up</button>
          </div>
            <div>
            {/* <button onClick={handleSignup} className={styles.customerPortal}>Customer Portal</button> */}
            </div>
        </div>
   

        {/* mobile nav */}
        <div className={styles.mobilenav}>
      {/* Hamburger / X Icon */}
      <div
        className={`${styles.hamburger} ${isOpen ? styles.open : ""}`}
        onClick={toggleMenu}
      >
        <span></span>
        <span></span>
        <span></span>
      </div>

      {/* Menu */}
      {isOpen && (
        <div className={styles.menus}>
          <nav className={styles.navs}>
            <a href="#home" onClick={toggleMenu} >Home</a>
            <a href="#services" onClick={toggleMenu}>Services</a>
            <a href="#about" onClick={toggleMenu}>About</a>
            <a href="#news" onClick={toggleMenu}>News</a>
            <a href="#contact" onClick={toggleMenu}>Contact</a>
          </nav>

          <div style={{display: "flex", flexDirection: "column", gap: "20px", justifyContent: "center", alignItems: "center"}}>
            <button className={styles.signIns} onClick={handleSignin}>Sign In</button>
            <button className={styles.signUps} onClick={handleSignup}>Sign Up</button>
            <button className={styles.customerPortals} onClick={handleSignup}>Customer Portal</button>
          </div>
        </div>
      )}
    </div>

      </header>

    

      {/* Hero Section */}
      <section
        className={`${styles.hero} ${
          inViewHero ? styles.fadeIn : styles.fadeOut
        }`}
        id="home"
        ref={refHero}>
      {/* <section id="home" className={styles.hero}> */}
        <p className={styles.mintext}>Welcome to</p>
        <h1 className={styles.herobghead}>Ogun State Water Corporation </h1>
        <h1 className={styles.highlight}>(OGSWC)</h1>
        <p className={styles.watertxt}>Water You Can Trust</p>
        {/* <p className={styles.mintext}> */}
        <div className={styles.heroButtons}>
          <button className={styles.primary} onClick={() => navigate('/login')}> 
          <div className={styles.primarylay}>
          <span>Pay Your Bill</span> <img src={icons} alt="purse" />
          </div>
          </button>
          <button className={styles.secondary} onClick={() => navigate('/signup')}>
          <div className={styles.secondarylay}>
          <span>Apply for New Connection</span>
          <img src={icons2} alt="arrow" />
          </div>
          </button>
        </div>
        <div className={styles.quickLinks}>
          <button onClick={() => navigate('/signup')}>
          <div className={styles.layminh}>
          <span>Validate Your Account</span>
          <img src={persons} alt="user" />
          </div>
          </button>
          <button>
          <div className={styles.layminh} onClick={() => navigate('/login')}>
          <span>Apply for Water Meter</span>
          <img src={spanner} alt="wrench" />
          </div>
          </button>
          <button  onClick={() => setShowModal(true)}>
          <div className={styles.layminh}>
          <span>Water Calculator</span>
          <img src={calculator} alt="calculator" />
          </div>
        </button>
        </div>
      </section>

      {/* Services Section */}

      <section
        className={`${styles.services} ${
          inViewServices ? styles.fadeIn : styles.fadeOut
        }`}
        id="services"
        ref={refServices}>
      {/* <section id="services" className={styles.services}> */}
        <h2 className={styles.bgservices}>Our Services</h2>
        <p className={styles.servicemin}>
        <span>Ogun State Water Corporation (OGSWC) is the official public utility responsible for the production, treatment, and distribution of potable water across Ogun State. Our commitment is to provide safe, reliable, and affordable water to households, businesses, and communities through efficient service delivery and responsible water management.</span>
        {/* <span>From new service connections to bill payments and customer support, our digital platform is designed to make water services more accessible and transparent for everyone.</span> */}
        </p>
        <div className={styles.serviceGrid}>
          {/* Service Card */}
          <div className={styles.card}>
            <img src={homes} alt="home" />
            <div className={styles.disp}>
            <h3 className={styles.headercard}>New Water Connection</h3>
            <p className={styles.textdtails}>
            <span>Get connected to our reliable water supply network</span>
            <span>with our streamlined application process.</span>
          </p>
            </div>
            <ul>
              <li className={styles.cadlist}>
              <div>
              <img className={styles.greens} src={greenmarks} alt="green marks" />
              </div>
              <span>Online application</span></li>        
              <li className={styles.cadlist} > 
              <div>
              <img className={styles.greens} src={greenmarks} alt="green marks" />
              </div>
              <span>Site inspection</span></li>
              <li className={styles.cadlist}>
              <div>
              <img className={styles.greens} src={greenmarks} alt="green marks" />
              </div>
              <span>Quick Installation</span>
              </li>
            </ul>
            <button className={styles.cardbtn} onClick={() => navigate('/signup')}>
            <span>Apply Now</span> 
            <img src={arrownxt} alt="arrownext" />
            </button>
          </div>

          <div className={styles.card}>
            <img src={purse} alt="wallet" />
            <div>
            <h3 className={styles.headercard}>Bill Payment</h3>
            <p className={styles.textdtails}>Pay your water bills conveniently through multiple channels including online, mobile, and physical appearance.</p>
            </div>
            <ul>
              <li className={styles.cadlist}>
              <div>
              <img className={styles.greens} src={greenmarks} alt="green marks" />
              </div><span>Online payment</span></li>
              <li className={styles.cadlist}>
              <div>
              <img className={styles.greens} src={greenmarks} alt="green marks" />
              </div><span>Bank transfers</span></li>
              <li className={styles.cadlist}>
              <div>
              <img className={styles.greens} src={greenmarks} alt="green marks" />
              </div>
              <span>Payment center</span></li>
            </ul>
            <button onClick={() => navigate('/login')} className={styles.cardbtn} ><span>Pay Bill</span> <div><img src={arrownxt} alt="arrownext" /></div></button>
          </div>

          <div className={styles.card}>
            <img src={work} alt="work" />
            <h3 className={styles.headercard}>Maintenance & Repairs</h3>
            <p className={styles.textdtails}>Report issues and schedule maintenance for your
            water connection with our responsive service team.</p>
            <ul>
              <li className={styles.cadlist}>
              <div>
              <img className={styles.greens} src={greenmarks} alt="green marks" />
              </div><span>24/7 emergency</span></li>

              <li className={styles.cadlist}>
              <div>
              <img className={styles.greens} src={greenmarks} alt="green marks" />
              </div><span>Scheduled maintenance</span></li>
              <li className={styles.cadlist}>
              <div>
              <img className={styles.greens} src={greenmarks} alt="green marks" />
              </div>
              <span>Quality assessment</span>
              </li>
            </ul>
            <button onClick={() => navigate('/login')} className={styles.cardbtn}><span>Report Issue</span> <div><img src={arrownxt} alt="arrownext" /></div></button>
          </div>

          <div className={styles.card}>
            <img src={invoice} alt="invoices" />
            <h3 className={styles.headercard}>Commercial Services</h3>
            <p className={styles.textdtails}>Specialized water solutions for businesses, industries, and large-scale developments.</p>
            <ul>
              <li className={styles.cadlist}>
              <div>
              <img className={styles.greens} src={greenmarks} alt="green marks" />
              </div> <span>Bulk supply</span></li>
              <li className={styles.cadlist}> 
              <div>
              <img className={styles.greens} src={greenmarks} alt="green marks" />
              </div><span>Custom solutions</span>
              </li>
              <li className={styles.cadlist}>
              <div>
              <img className={styles.greens} src={greenmarks} alt="green marks" />
              </div>
              <span>Priority support</span></li>
            </ul>
            <button onClick={(e) => handleSmoothScroll(e, "about")} className={styles.cardbtn}><span>Learn More</span> <div><img src={arrownxt} alt="arrownext" /></div></button>
          </div>

          <div className={styles.card}>
            <img src={invoices} alt="Reports Icon" />
            <h3 className={styles.headercard}>Water Quality Reports</h3>
            <p className={styles.textdtails}> Access detailed water quality reports and
              certifications to ensure safety and compliance.</p>
            <ul>
              <li className={styles.cadlist}>
              <div>
              <img className={styles.greens} src={greenmarks} alt="green marks" />
              </div> <span>Monthly reports</span>
              </li>
              <li className={styles.cadlist}>
              <div>
              <img className={styles.greens} src={greenmarks} alt="green marks" />
              </div> <span>Safety standards</span></li>
              <li className={styles.cadlist}>
              <div>
              <img className={styles.greens} src={greenmarks} alt="green marks" />
              </div>
              <span>Public access</span></li>
            </ul>
            <button className={styles.cardbtn}><span>View Reports</span> <div><img src={arrownxt} alt="arrownext" /></div></button>
          </div>

          <div className={styles.card}>
            <img src={telephone} alt="Telephone Icon" />
            <h3 className={styles.headercard}>Customer Support</h3>
            <p className={styles.textdtails}>
            Get help with any water-related queries through our dedicated customer service channels.</p>
            <ul>
              <li className={styles.cadlist}>
              <div>
              <img className={styles.greens} src={greenmarks} alt="green marks" />
              </div>
              <span>24/7 support</span>
              </li>
              <li className={styles.cadlist}> 
              <div>
              <img className={styles.greens} src={greenmarks} alt="green marks" />
              </div>
              <span>Email & phone</span></li>
              <li className={styles.cadlist}> 
              <div>
              <img className={styles.greens} src={greenmarks} alt="green marks" />
              </div>
              <span>Contact form</span>
              </li>
            </ul>
            <button  onClick={(e) => handleSmoothScroll(e, "contact")} className={styles.cardbtn}><span>Contact Us</span><div><img src={arrownxt} alt="arrownext" /></div></button>
          </div>
        </div>
      </section>

      {/* Assistance Section */}
      <section className={styles.assistance}>
        <h3 className={styles.astext}>Customer Support / Help Center </h3>
        <p className={styles.txtflex}>
        <span> OGSWC operates a toll-free customer line (0708 060 1161) to assist residents with inquiries, </span>
        <span>complaints, and service requests.</span>       
        </p>
        <div className={styles.assistanceButtons}>
          <button className={styles.call}><img src={calls} alt="phone" className={styles.phonepic} /> 
          <a href="tel:+234 708 060 1161">Call:+234 708 060 1161</a>
          </button>
          {/* <button className={styles.email}>Send an Email</button> */}
        </div>
      </section>

      <div className={styles.tttTop}>
    <div className={styles.topTp}>
        {/* About */}

        <section
        className={`${styles.aboutss} ${
          inViewAbout ? styles.fadeIn : styles.fadeOut
        }`}
        id="about"
        ref={refAbout}>
        {/* <section id="about"> */}
            <div className={styles.topCore}>
                <div className={styles.coreOne}>
                    <h4 className={styles.coreHd}>About Ogun State Water Corporation</h4>
                    <p className={styles.coreP}>Ogun State Water Corporation is dedicated to ensuring sustainable access to clean and affordable water across the state. We operate with a strong focus on innovation, integrity, and community engagement, supporting public health and economic development.</p>
        {/* <p className={styles.coreP}>To strengthen service delivery and infrastructure development, OGSWC has benefited from various Federal Government and donor-assisted interventions, including projects funded by the World Bank, African Development Bank (AfDB), Agence Française de Développement (AFD), and other development partners. Notable among these are the National Urban Water Sector Reform Project (NUWSRP) and the AFD-funded Ogun Urban Water Supply Project, which focused on rehabilitation, expansion, institutional reform, and capacity building.</p>
        <p className={styles.coreP}>In line with national sector reforms, OGSWC has undergone several institutional and operational changes aimed at improving efficiency, financial sustainability, and customer service. These reforms include corporatization efforts, introduction of metering programmes, commercialization initiatives, and adoption of modern data management and billing systems.</p>
        <p className={styles.coreP}>Today, the Ogun State Water Corporation remains the principal agency responsible for public water supply in Ogun State, working in collaboration with the Ogun State Ministry of Environment, Ogun State Water Management Agency (OGWAMA), and relevant Federal Ministries to achieve sustainable and equitable access to safe water in line with national and global development goals.</p> */}
        <div className={styles.ssions}>
            <div className={styles.ourMision}>
                <h4>Our Mission</h4>
                <p>Our mission is to ensure every resident of Ogun State has access to clean, affordable, and reliable water by championing long-term, eco-friendly solutions.</p>
            </div>
            <div className={styles.ourVision}>
                <h4>Our Vision</h4>
                <p>Our vision is to provide safe, sustainable, and accessible water services by leveraging advanced technologies to improve efficiency, reliability, and environmental stewardship for the people of Ogun State.</p>
            </div>
            <div className={styles.ourVision}>
                <h4>Our Core Values</h4>
                <p>Integrity, accountability, excellence, sustainability, and customer focus guide all our operations and decision-making processes.</p>
            </div>
            <div className={styles.ourVision}>
                <h4>Our History & Structure</h4>
                <p>Since establishment, OGSWC has expanded water infrastructure, improved treatment capacity, and strengthened service delivery through dedicated departments and professional leadership.</p>
            </div>
        </div>
                </div>
                <div className={styles.coreTwo}>
                    <h4 className={styles.crValue}>Our Core Values</h4>
                    <div className={styles.crDiv}>
                        <div className={styles.crSub}>
                            <div className={styles.bgDiv}>
                            <img src={exe} className={styles.bgExe}/>
                            </div>
                            <div>
                                <h4 className={styles.exeText}>Excellence</h4>
                                <p className={styles.exeP}>Committed to delivering the highest quality water services through
        continuous improvement and innovation.</p>
                            </div>
                        </div>
                      
                    </div>

                    <div className={styles.crDiv}>
                        <div className={styles.crSub}>
                            <div className={styles.bgDiv}>
                            <img src={community} className={styles.bgExe}/>
                            </div>
                            <div>
                                <h4 className={styles.exeText}>Community Focus</h4>
                                <p className={styles.exeP}>Serving every community in Ogun State with equal dedication and
        ensuring no one is left behind.</p>
                            </div>
                        </div>
                      
                    </div>

                    <div className={styles.crDiv}>
                        <div className={styles.crSub}>
                            <div className={styles.bgDiv}>
                            <img src={rely} className={styles.bgExe}/>
                            </div>
                            <div>
                                <h4 className={styles.exeText}>Reliability</h4>
                                <p className={styles.exeP}>Providing consistent, uninterrupted water supply through robust
        infrastructure and proactive maintenance.</p>
                            </div>
                        </div>
                      
                    </div>

                    <div className={styles.crDiv}>
                        <div className={styles.crSub}>
                            <div className={styles.bgDiv}>
                            <img src={love} className={styles.bgExe}/>
                            </div>
                            <div>
                                <h4 className={styles.exeText}>Sustainability</h4>
                                <p className={styles.exeP}>Protecting our water resources for future generations through
        responsible management and conservation.</p>
                            </div>
                        </div>
                      
                    </div>

                </div>
            </div>
        </section>

    {/* Metrics */}
    <div className={styles.metricTop}>
        <div className={styles.metricsDiv}>
            <h4>7,000+</h4>
            <p>Active Customers</p>
        </div>
        <div className={styles.metricsDiv}>
            <h4>20+</h4>
            <p>Local Governments</p>
        </div>
        <div className={styles.metricsDiv}>
            <h4>1000+</h4>
            <p>KM of Pipelines</p>
        </div>
        <div className={styles.metricsDiv}>
            <h4>50+</h4>
            <p>Years of Service</p>
        </div>
    </div>

    {/* News */}
    
    </div>
    <section
        className={`${styles.newss} ${
          inViewNews ? styles.fadeIn : styles.fadeOut
        }`}
        id="news"
        ref={refNews}>
    {/* <section id="news"> */}
    <div className={styles.divNews}>
        <h4 className={styles.hdNews}>Latest News & Updates</h4>
        <p className={styles.hdPrg}>Stay informed about our latest developments, service improvements, and <br />
community initiatives.</p>
<div className={styles.tpNews}>
    <div className={styles.crdNews}>
        <div style={{position:'relative'}}>
        <img src={img} className={styles.imgImg}/>
        <div className={styles.label}>Government</div>
        </div>
        <div className={styles.dtCrd}>
        <div className={styles.dateDiv}>
            <img src={date} /><p>January 10, 2024</p>
        </div>
        <h4 className={styles.tlt}>Facility Tours by SA on SDGs and
Water Resources</h4>
<p className={styles.advDtl}>The Special Adviser (SA) to the Ogun State
Governor on Sustainable Development Goals
(SDGs) and Water Resources, Hon. Damilola
Otubanjo, has been actively involved in facility tours
to assess and improve...</p>
<div className={styles.rdMore}>Read More <img src={arrow}/></div>
</div>
    </div>
     <div className={styles.crdNews}>
        <div style={{position:'relative'}}>
        <img src={img2} className={styles.imgImg}/>
        <div className={styles.label}>Government</div>
        </div>
        <div className={styles.dtCrd}>
        <div className={styles.dateDiv}>
            <img src={date} /><p>January 10, 2024</p>
        </div>
        <h4 className={styles.tlt}>Facility Tours by SA on SDGs and
Water Resources</h4>
<p className={styles.advDtl}>The Special Adviser (SA) to the Ogun State
Governor on Sustainable Development Goals
(SDGs) and Water Resources, Hon. Damilola
Otubanjo, has been actively involved in facility tours
to assess and improve...</p>
<div className={styles.rdMore}>Read More <img src={arrow}/></div>
</div>
    </div>
    
     <div className={styles.crdNews}>
       <div style={{position:'relative'}}>
        <img src={img3} className={styles.imgImg}/>
        <div className={styles.label}>Government</div>
        </div>
        <div className={styles.dtCrd}>
        <div className={styles.dateDiv}>
            <img src={date} /><p>January 10, 2024</p>
        </div>
        <h4 className={styles.tlt}>Facility Tours by SA on SDGs and
Water Resources</h4>
<p className={styles.advDtl}>The Special Adviser (SA) to the Ogun State
Governor on Sustainable Development Goals
(SDGs) and Water Resources, Hon. Damilola
Otubanjo, has been actively involved in facility tours
to assess and improve...</p>
<div className={styles.rdMore}>Read More <img src={arrow}/></div>
</div>
    </div>
</div>
<button className={styles.viewBtn}>View All News <img src={arBlk} style={{marginLeft:15}}/></button>
    </div>
    </section>

    {/* Get in touch */}
    
    <section
        className={`${styles.contactus} ${
          inViewContactUs ? styles.fadeIn : styles.fadeOut
        }`}
        id="contact"
        ref={refContactUs}>
    {/* <section id="contact"> */}
    <div className={styles.gtTOuch}>
        <h4 className={styles.touch}>Reach Ogun State Water Corporation</h4>
        <p className={styles.touchP}>We're here to help with all your water service needs. Contact us through any of the<br />
channels below or on <span style={{color: '#174578', fontWeight: 700}}>+2347080601161, +2348068241741 (WhatsApp)</span></p>
<div className={styles.divMsg}>
    <div className={styles.divF}>
        <div className={styles.divFst}>
             
            <div className={styles.ddTp}><div className={styles.bgDivs}>
                    <img src={loc} className={styles.bgExe}/>
            </div> <p className={styles.head}>Head Office</p> </div>
            <p className={styles.ppr}>Presidential Boulevard, Oke-Mosan, Abeokuta, P.M.B 2074.</p>
            {/* <p className={styles.ppr1}>Abeokuta, Ogun State</p> */}
            <p className={styles.ppr1}>Nigeria</p>
        </div>
         {/* <div className={styles.divFst}>
             
            <div className={styles.ddTp}><div className={styles.bgDivs}>
                    <img src={call} className={styles.bgExe}/>
            </div> <p className={styles.head}>Phone Numbers</p> </div>
            <p className={styles.ppr}> 0708 060 1161, 0806 824 1741</p>
           
        </div> */}
         <div className={styles.divFst}>
             
            <div className={styles.ddTp}><div className={styles.bgDivs}>
                    <img src={mail} className={styles.bgExe}/>
            </div> <p className={styles.head}>Email Addresses</p> </div>
            <p className={styles.ppr}>info@ogswc.ogunstate.gov.ng</p>
            <p className={styles.ppr1}>support@ogswc.ogunstate.gov.ng</p>
            {/* <p className={styles.ppr1}>Phone No.: +2347080601161, +2348068241741</p> */}
            {/* <p className={styles.ppr1}>billing@ogswc.ogunstate.gov.ng</p> */}
        </div>
         <div className={styles.divFst}>
             
            <div className={styles.ddTp}><div className={styles.bgDivs}>
                    <img src={hour} className={styles.bgExe}/>
            </div> <p className={styles.head}>Office Hours</p> </div>
            <p className={styles.ppr}>Monday - Friday: 8:00 AM - 5:00 PM</p>
            <p className={styles.ppr1}>Saturday: 9:00 AM - 2:00 PM</p>
            {/* <p className={styles.ppr1}>Emergency Services: 24/7</p> */}
        </div>
         <div className={styles.divFst}>
             
            <div className={styles.ddTp}><div className={styles.bgDivs}>
                    <img src={hour} className={styles.bgExe}/>
            </div> <p className={styles.head}>Social Media Platforms</p> </div>
            <p className={styles.ppr}>Instagram: @ogsgwatercorp
</p>
            <p className={styles.ppr1}>Facebook: Ogun State Water Corporation
</p>
            <p className={styles.ppr1}>X(twitter): @ogsgwatercorp
</p>
            {/* <p className={styles.ppr1}>Emergency Services: 24/7</p> */}
        </div>
        <div className={styles.divHelp}>
            <div className = {styles.helpOne}>
                <img src={chat} /><h4>Need Immediate Help?</h4>
            </div>
            <p className={styles.prgHelp}>Our customer service team is available 24/7 for
emergencies and urgent enquiries.</p>
<button className={styles.btnLive}>Start Live Chat</button>

        </div>
    </div>
    <div className={styles.messageDiv}>
        <h4 className={styles.sendMss}>Send us a Message</h4>
        <p className={styles.prgMsg}>Fill out the form below and we'll get back to you within 24 hours.</p>
        <div className={styles.frmMss}>
            <div className={styles.textMss}>
                <label>First Name</label>
                <input type='text' placeholder='Enter your first name'/>
            </div>
            <div className={styles.textMss}>
                <label>Last Name</label>
                <input type='text' placeholder='Enter your last name'/>
            </div>
        </div>
        <div className={styles.frmMss}>
            <div className={styles.textMss}>
                <label>Email Address</label>
                <input type='email' placeholder='Enter your email'/>
            </div>
            <div className={styles.textMss}>
                <label>Phone Number</label>
                <input type='text' placeholder='Enter your phone number'/>
            </div>
        </div>
        <div className={styles.textMssbj}>
            <label>Subject</label>
            <input type='text' placeholder='What is this regarding?'/>
        </div>
        <div className={styles.messTxt}>
            <label>Message</label>
            <textarea rows={3} cols={90} placeholder='Please describe your inquiry or concern in detail...'></textarea>
        </div>
        <button className={styles.sendBtn2}>
            <img src={fly} /><p>Send Message</p>
        </button>
            <p className={styles.privacy}>By submitting this form, you agree to our privacy policy and terms of service.</p>
    </div>
</div>

    </div>
    </section>
    

    {/* Footer */}
    <div className={styles.footer}>

        <div className={styles.ftTp}>
            <div className={styles.ftTp1}>
                <h4>Stay Updated</h4>
                <p>Subscribe to our newsletter for the latest updates on water services,
maintenance schedules, and community news.</p>
            </div>
            <div className={styles.ftTp2}>
                <input placeholder='Enter your email address'/>
                <button><img src={fly}/></button>
            </div>
        </div>

        <div className={styles.line}></div>
        <div className={styles.trd}>
            <div className={styles.trdOne}>
                <div className={styles.divLg}>
                    <img src={ogswc} className={styles.logos}/>
                    <div className={styles.lotxt}>
                        <h4>OGSWC</h4>
                        <p>Ogun State Water Corporation</p>
                    </div>
                </div>
                <p className={styles.lebter}>Providing reliable, safe, and affordable water
services to communities across Ogun State through
modern infrastructure and exceptional customer
service.</p>
<div className={styles.igt}><img src={loc} /><p>Presidential Boulevard, Oke-Mosan, Abeokuta, P.M.B 2074.</p></div>
<div className={styles.igt}><img src={call} /><p>+2347080601161, +2348068241741</p></div>
<div className={styles.igt}><img src={mail} /><p>info@ogswc.ogunstate.gov.ng</p></div>
<div className={styles.socialIcon}>
    <img src={facebook}/>
    <img src={twitter}/>
    <img src={instagram}/>
    <img src={linkedln}/>
</div>
            </div>
            <div className={styles.trdTwo}>
                <h4>Services</h4>
                <p>New Connection</p>
                <p>Bill Payment</p>
                <p>Maintenance</p>
                <p>Commercial Services</p>
                <p>Water Quality</p>
                <p>Customer Support</p>
            </div>
            <div className={styles.trdTwo}>
                <h4>Company</h4>
                <p>About Us</p>
                <p>Leadership</p>
                <p>Careers</p>
                <p>Servies</p>
                <p>Sustainability</p>
                <p>Community</p>
            </div>
            <div className={styles.trdTwo}>
                <h4>Resources</h4>
                <p>Customer Portal</p>
                <p>Payment Centers</p>
                <p>Service Areas</p>
                <p>Water Conservation</p>
                <p>Emergency Contacts</p>
                <p>FAQs</p>
            </div>
             <div className={styles.trdTwo}>
                <h4>Legal</h4>
                <p>Privacy Policy</p>
                <p>Terms of Service</p>
                <p>Billing Policy</p>
                <p>Service Agreement</p>
                <p>Complaints Procedure</p>
                <p>Accessibility</p>
            </div>
        </div>
         <div className={styles.line}></div>

         <div className={styles.btmFooter}>
            <p className={styles.ogText}>© {year} Ogun State Water Corporation. All rights reserved.</p>
            <div className={styles.prText}>
                <p>Privacy Policy</p>
                <p>Terms of Service</p>
                <p>Accessibility</p>
            </div>
         </div>


    </div>
    </div>
      

    </div>
  );
};

export default HomePage;
